function resourcesAsOptions({
  companiesCollection = null,
  resourceIdentifier,
  resourcesCollection,
}) {
  return resourcesCollection.map((resource) => ({
    value: parseInt(resource.id, 10),
    label: resource.attributes[resourceIdentifier],
    sublabel:
      companiesCollection &&
      companiesCollection.find(
        (company) => company.id === String(resource.attributes.companyId),
      ).attributes.name,
  }));
}

function selectedResources(assignableResources, assignedIds) {
  return assignableResources.filter((resource) =>
    assignedIds.includes(parseInt(resource.id, 10)),
  );
}

export { resourcesAsOptions, selectedResources };
